<template>
  <v-card class="d-flex flex-column fill-height pa-3 pt-0" style="width: 100%">
    <v-card-title class="pb-0">
      <span class="table-card-title">Notificação Push</span>
    </v-card-title>
    <div class="push-preview d-flex flex-column flex-grow-1">
      <div class="outer-frame-push">
        <v-layout style="flex: 0 0 auto">
          <v-flex xs4>
            <v-layout>
              <v-spacer />
              <div class="camera-slot" />
            </v-layout>
          </v-flex>
          <v-flex xs4 class="ear-speaker-slot" />
          <v-flex xs4 />
        </v-layout>
        <div class="inner-frame-push">
          <div class="push-notification d-flex align-center justify-space-between">
            <div style="max-width: 100%">
              <div class="application-icon-slot" />
              <span class="secondary-text push-application-name">{{ $t('campanhas.mercafacil') }}</span>
              <span class="primary-text push-title">{{ notificationTitle }}</span>
              <span class="secondary-text push-caption">{{ notificationText }}</span>
            </div>
          </div>
          <div v-if="hasInnerMessage" class="inner-message-card">
            <p class="mf-h6">
              {{ calculatedInnerMessageTitle }}
            </p>
            <p class="mf-subtitle-1">
              {{ calculatedInnerMessageText }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'PushNotificationPreview',

  props: {
    notificationTitle: {
      type: String,
      default: '',
    },
    notificationText: {
      type: String,
      default: '',
    },
    innerMessageTitle: {
      type: String,
      default: '',
    },
    innerMessageText: {
      type: String,
      default: '',
    },
  },

  computed: {
    calculatedInnerMessageTitle() {
      return this.innerMessageTitle || this.notificationTitle
    },
    calculatedInnerMessageText() {
      return this.innerMessageText || this.notificationText
    },
    hasInnerMessage() {
      return this.calculatedInnerMessageTitle || this.calculatedInnerMessageText
    },
  },
}
</script>

<style lang="scss" scoped>
$tablet-size: 960px;

.push-preview {
  p,
  span {
    max-width: inherit;
    max-height: inherit;
    word-wrap: break-word;
  }

  .outer-frame-push {
    border: 2px solid $cinza-l80;
    border-radius: 40px 40px 0 0;
    border-bottom: 0;
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
    @media screen and (max-width: $tablet-size) {
      padding: 4vh 3vw;
      margin: 1vh 1vw;
    }
    @media screen and (min-width: $tablet-size) {
      margin: 1vh 1vw 0;
      padding: 4vh 3vw 0;
    }

    .camera-slot {
      border: 2px solid $cinza-l80;
      border-radius: 20px;
      display: inline-block;
      margin-bottom: 5vh;
      height: 2vh;
      width: 2vh;
      margin-right: 0.8vw;
    }

    .ear-speaker-slot {
      border: 2px solid $cinza-l80;
      border-radius: 30px;
      display: inline-block;
      margin-bottom: 5vh;
      height: 2vh;
      width: 10vw;
      margin-left: 0.8vw;
    }

    .inner-frame-push {
      border: 2px solid $cinza-l80;
      border-bottom: 0;
      display: flex;
      flex-direction: column;
      flex: 1 1 auto;
      min-height: 0;

      .push-notification {
        background-color: $cinza-l90;
        padding: 1.6vw;
        flex: 0 0 auto;

        .application-icon-slot {
          background-color: $branco;
          width: 0.8vw;
          height: 0.8vw;
          display: inline-block;
          border-radius: 2px;
        }

        .push-application-name {
          padding-left: 0.8vw;
          font-size: 10px;
          display: inline-block;
        }

        .push-title {
          padding-left: 1.6vw;
          font-size: 20px;
          display: block;
        }

        .push-caption {
          padding-left: 1.6vw;
          font-size: 18px;
          display: block;
        }
      }

      .inner-message-card {
        background-color: $branco;
        border: 2px solid $cinza-l80;
        padding: 16px;
        margin: 16px;
        border-radius: 0 0 8px 8px;
        flex-shrink: 0;

        p {
          margin-bottom: 8px;

          &:last-child {
            margin-bottom: 0;
          }
        }

        .mf-h6 {
          font-weight: 600;
          font-size: 16px;
          line-height: 1.4;
        }

        .mf-subtitle-1 {
          font-size: 14px;
          line-height: 1.5;
          color: $cinza-d10;
        }
      }
    }
  }
}
</style>
